import masterFile from './MasterFile/masterFileStore';

export default {
  namespaced: true,
  modules: {
    masterFile,
  },
};